export default {
  mounted () {
    this.$router.app.$emit('setTitleEvent', this.headerTitle)
  }
}
